import React from "react";

import { KgCollapsedIconShell } from "../../kg/canvas/components/KgCollapsedIconShell";
import { KgNodeIconBadge } from "../../atoms/KgNodeIconBadge";
import type { KgCollapsedNodeHoverProps } from "./KgCollapsedNodeHover.types";

export const KgCollapsedNodeHover: React.FC<KgCollapsedNodeHoverProps> = ({
  icon,
  color,
  bgColor,
  visualState = "default",
  title,
  subtitle,
  logoUrl,
  logoName,
  className,
}) => (
  <KgCollapsedIconShell
    title={title}
    subtitle={subtitle}
    logoUrl={logoUrl}
    logoName={logoName ?? title}
  >
    <KgNodeIconBadge
      icon={icon}
      color={color}
      bgColor={bgColor}
      visualState={visualState}
      className={className}
    />
  </KgCollapsedIconShell>
);

export default KgCollapsedNodeHover;
